<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="data?.name"
  [description]="description"
  [media]="imageUrl"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
